// src/pages/batch/hooks/useMoleculeImages.js
import { useState, useEffect, useCallback, useRef } from "react";
import { generateImagesFromSmiles } from "../../../../util/ChemDrawUtils";

export const useMoleculeImages = (pagedData) => {
  const [images, setImages] = useState({});
  const inFlightRef = useRef(new Set()); // prevent duplicate ChemDraw calls

  const ensureImages = useCallback(
    async (smilesList) => {
      const uniques = Array.from(new Set(smilesList.filter(Boolean)));
      const toGen = uniques.filter((s) => !images[s] && !inFlightRef.current.has(s));
      if (!toGen.length) return;

      toGen.forEach((s) => inFlightRef.current.add(s));
      try {
        const urls = await generateImagesFromSmiles(toGen);
        const map = {};
        toGen.forEach((s, i) => (map[s] = urls[i]));
        setImages((prev) => ({ ...prev, ...map }));
      } catch {
        // noop
      } finally {
        toGen.forEach((s) => inFlightRef.current.delete(s));
      }
    },
    [images]
  );

  useEffect(() => {
    const smilesNeeded = new Set();
    const moleculeIdMap = [];

    pagedData.forEach((row) => {
      if (row?.smile) smilesNeeded.add(row.smile);
      if (row?.molecule_id && row?.smile && !images[row.molecule_id]) {
        moleculeIdMap.push(row);
      }
    });

    const smilesArr = Array.from(smilesNeeded);
    if (!smilesArr.length && moleculeIdMap.length === 0) return;

 (async () => {
      await ensureImages(smilesArr);
      // map the base molecule ID to its smile image using latest state
      setImages((prev) => {
        const patch = {};
        moleculeIdMap.forEach((item) => {
          const url = prev[item.smile];
          if (url) patch[item.molecule_id] = url;
        });
        return Object.keys(patch).length ? { ...prev, ...patch } : prev;
      });
    })();
  }, [pagedData, ensureImages, images]);

  return { images, ensureImages };
};
